var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"loginBox",on:{"click":function($event){return _vm.show()}}},[_c('div',{attrs:{"id":"login_container"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }